import { defineStore } from 'pinia'

const useRedirectRulesStore = defineStore('redirectRules', {
  state: () => ({}),
  actions: {},
})

export default useRedirectRulesStore
